export default [
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/menu/order/order.vue'),
    meta: {
      pageTitle: 'مدیریت سفارش ها',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/order/details',
    name: 'adddorder',
    component: () => import('@/views/menu/order/orderDetails.vue'),
    meta: {
      pageTitle: 'ایجاد سفارش',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/order/details/:id',
    name: 'updateorder',
    component: () => import('@/views/menu/order/orderDetails.vue'),
    meta: {
      pageTitle: 'ویرایش سفارش',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/order/abandoned',
    name: 'abandonedorder',
    component: () => import('@/views/menu/order/abandonedorder.vue'),
    meta: {
      pageTitle: 'سفارش های رها شده',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/dutyorder',
    name: 'dutyorder',
    component: () => import('@/views/menu/order/dutyorder.vue'),
    meta: {
      pageTitle: 'مدیریت سفارش ها',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/dutyorder/details/:id',
    name: 'updatedutyorder',
    component: () => import('@/views/menu/order/dutyorderdetails.vue'),
    meta: {
      pageTitle: 'ویرایش سفارش',
      action: 'show',
      resource: 'OrderManager',
    },
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import('@/views/menu/order/coupon.vue'),
    meta: {
      pageTitle: 'مدیریت تخفیف ها',
      action: 'show',
      resource: 'CouponManager',
    },
  },
  {
    path: '/coupon/details',
    name: 'addcoupon',
    component: () => import('@/views/menu/order/coupondetails.vue'),
    meta: {
      pageTitle: 'ایجاد تخفیف',
      action: 'show',
      resource: 'CouponManager',
    },
  },
  {
    path: '/coupon/details/:id',
    name: 'updatecoupon',
    component: () => import('@/views/menu/order/coupondetails.vue'),
    meta: {
      pageTitle: 'ویرایش تخفیف',
      action: 'show',
      resource: 'CouponManager',
    },
  },
]
